import { gql } from "../__generated__";

export const GetObjectItems = gql(`
  query GetObjectItems($take: Int, $where: ObjektEigenschaftVolkskundeWhereInput) {
    items: objektEigenschaftVolkskundes(take: $take, where: $where) {
      id
      name
    }
  }
`);
